import axios from 'axios'
import { Printd } from 'printd'


export default function (context, val) {
    let action = val.action || 'edit';
    let item = context.getters.item(val.templateId);
    if (!item) return;
    let selections = context.getters.selections;

    if (item.NeedSelectedData.length && !selections.length) {
        window.app.$notify({
            message: 'Нужно выбрать платежи',
            type: 'warning'
        });
        return;
    }
    let url = '';
    if (action === 'print') {
        let d = new Printd();
        let printFrame = document.createElement("div");
        printFrame.innerHTML = 'printed area...';
        const { contentWindow } = d.getIFrame();
        contentWindow.addEventListener(
            'afterprint', () => {
                printFrame.innerHTML = '';
            }
        );
        let cssText = `
                      .box {
                        font-family: sans-serif;
                        width: 500px;
                        border: solid 1px #ccc;
                        text-align: center;
                        padding: 1em;
                        margin: 2em auto;
                      }

                      button {
                        background-color: #f0f0f0;
                        border: solid 1px #ccc;
                        padding: 5px 10px;
                        font-size: 12px;
                      }

                      pre {
                        color: #c7254e;
                      }
                `;

        let agCode;
        let agId;
        if (selections.length === 1) {
            agCode = selections[0].Code;
            agId = selections[0].Id;
        } else {
            agCode = selections.reduce((string, current, index) => {
                return index === 0 ? (string + current.Code) : (string + ',' + current.Code)
            }, '')
            agId = selections.reduce((string, current, index) => {
                return index === 0 ? (string + current.Id) : (string + ',' + current.Id)
            }, '')
        }
        url = `/tourclient/report/GeneratedReport?WebReportId=${item.WebReportId}&reportTemplateID=${item.TemplateId}&parameters[reportID]=${item.Id}&parameters[AG_Code]=${agCode}&parameters[AG_ID]=${agId}`;

        // получаем html код отчета и вставляем его в область для печати
        axios({url: url, method: 'get'})
            .then(({data}) => {
                printFrame.innerHTML = data;
                d.print(printFrame, cssText);
            })
            .catch(() => {
                window.app.$notify({
                    message: 'Ошибка получения данных',
                    type: 'error'
                });
            });
        return
    } else if (action === 'download') {
        // if (item.NeedScreenFilter) {
        //     url = item.Url;
        //     url += context.getters.form_data;
        //     window.open(url);
        //     return;
        // }


        url = '/tourclient/report/report?';
        url += '&ReportID=' + item.Id;
        url += '&ReportTemplateID=' + item.TemplateId;
        url += '&WebReportId=' + item.WebReportId;

        if (item.NeedSelectedData && item.NeedSelectedData.length) {
            let a = '';
            item.NeedSelectedData.forEach(i => {
                selections.forEach(j => {
                    if (a) a += ',';
                    a += j[i];
                });
                a = encodeURIComponent('parameters[' + i + ']') + '=' + a;
            });
            url += '&' + a;
        }
        axios({
            method: 'get',
            url: url
        }).then(({data}) => {
            this.fields = [];
            if (data.Fields && data.Fields.length) {
                window.app.$modal({
                    type: 'reports',
                    fields: data.Fields,
                    onAccept: val => {
                        let url = item.Url + val;
                        if (selections.length) {
                            let a = '';
                            for (let i = 0; i < this.template.NeedSelectedData.length; i++) {
                                selections.forEach(j => {
                                    if (a) a += ',';
                                    a += j[item.NeedSelectedData[i]];
                                });
                                url += '&' + encodeURIComponent('parameters[' + item.NeedSelectedData[i] + ']') + '=' + encodeURIComponent(a);
                            }
                        }
                        window.open(url);
                    }
                });
            } else {
                window.open(url);
            }
        });
    } else {
        url = '/tourclient/report/getReportFilterFields?';
        url += '&ReportID=' + item.Id;
        url += '&ReportTemplateID=' + item.TemplateId;
        url += '&WebReportId=' + item.WebReportId;
        if (item.NeedSelectedData && item.NeedSelectedData.length) {
            let a = '';
            item.NeedSelectedData.forEach(i => {
                selections.forEach(j => {
                    if (a) a += ',';
                    a += item[i];
                });
                a = encodeURIComponent(i + '=' + a);
            });
            url += '&SelectedData=' + a;
        }
        axios({
            method: 'get',
            url,
        }).then(({data}) => {
            if (data.Fields && data.Fields.length) {
                item.fields = data.Fields;
                window.app.$dialog('reports',{
                    item: item,
                    change: val=>{
                        context.dispatch('open', item);
                    },
                })
            } else {
                context.dispatch('open', item);
            }
        }).catch(e => {
            context.dispatch('error', e, {root: true});
        });
    }
}
